'use strict'

import React from 'react'
import './LoadingBlock.css'
import LottieLoader from './LottieLoader'

function LoadingBlock () {
  return (
    <div className="preloader-wrapper">
      <LottieLoader/>
    </div>
  )
}

export default LoadingBlock